// Support-portal (Clinic Success Admin / Manager) APIs for managing a clinic
// location's OOH (appointment/token) screens, AUMHUM kiosks, and live preview.
// Backend: /api/secure/cc/support/ooh/* (see SupportOohController).
import { getSPDataWithParams, postSPDataWithoutParams } from './services'

export async function getSupportOohScreens(clinicLocationId) {
  return getSPDataWithParams('/api/secure/cc/support/ooh/screens', { clinicLocationId })
}

export async function getSupportKiosks(clinicLocationId) {
  return getSPDataWithParams('/api/secure/cc/support/ooh/kiosks', { clinicLocationId })
}

export async function saveSupportOohConfig(payload) {
  return postSPDataWithoutParams('/api/secure/cc/support/ooh/config', payload)
}

export async function getSupportOohPreview(clinicLocationId, mentorId) {
  return getSPDataWithParams('/api/secure/cc/support/ooh/preview', { clinicLocationId, mentorId })
}
